/**
 * KashIO Core EXT r.1.0.0.a
 * KashIO Core EXT Release 1.0.0.a
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {  Injectable }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import { Observable }                                        from 'rxjs';
import { Invoice } from '../_models/invoice.interface';
import { InvoiceList } from '../_models/invoiceList.interface';
import {NotificationList} from '../_models/notificationlist.interface';
import {AppConfig} from '../_helpers/appconfig.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { InvoiceReportExport } from "../_models/invoiceReportExport.interface";
import { Configuration, PartialInvoice, PaymentConfigurationValues, Values } from '../_models';

@Injectable()
export class InvoicesService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

    httpOptions:any;
    kashioApplication: any;
    public defaultHeaders = new HttpHeaders();
   
    constructor(protected httpClient: HttpClient) {
        this.kashioApplication = localStorage.getItem("application")
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    
    public getInvoiceConfiguration(publicId: string, url: any): Observable<Configuration<PaymentConfigurationValues>> {
        if (publicId == null) {
            throw new Error('Required parameter publicId was null or undefined when calling the custom design configuration details.');
        }
        return this.httpClient.get<Configuration<PaymentConfigurationValues>>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/${url}`);
    }

    /**
     * create_invoice
     * create_invoice
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createInvoice(body: Invoice, observe?: 'body', reportProgress?: boolean): Observable<Invoice>;
    public createInvoice(body: Invoice, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Invoice>>;
    public createInvoice(body: Invoice, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Invoice>>;
    public createInvoice(body: Invoice, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createInvoice.');
        }

        let headers = this.defaultHeaders;
  
        return this.httpClient.post<Invoice>(`${this._kcmssvcURL}/invoices`,
            body,
            {
                withCredentials: null,
                headers: headers,
                observe: 'response',
                reportProgress: reportProgress
            }
        );
    }

    /**
     * delete_invoice
     * delete_invoice
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteInvoice(publicId: string, observe?: 'body', reportProgress?: boolean): Observable<Invoice>;
    public deleteInvoice(publicId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Invoice>>;
    public deleteInvoice(publicId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Invoice>>;
    public deleteInvoice(publicId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling deleteInvoice.');
        }

        let headers = this.defaultHeaders;

        return this.httpClient.delete<Invoice>(`${this._kcmssvcURL}/invoices/${encodeURIComponent(String(publicId))}`,
            {
                withCredentials: null,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * get_invoice
     * get_invoice
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInvoice(publicId: string, observe?: 'body', reportProgress?: boolean): Observable<Invoice>;
    public getInvoice(publicId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Invoice>>;
    public getInvoice(publicId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Invoice>>;
    public getInvoice(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getInvoice.');
        }

        let headers = this.defaultHeaders;
        var url;
        if (this.kashioApplication == "PAYMENTS") {
            url = `${this._kcmssvcURL}/invoices/${encodeURIComponent(String(publicId))}?data=APP_PAYMENTS`;
        } else if (this.kashioApplication == "PAYOUTS") {
            url = `${this._kcmssvcURL}/invoices/${encodeURIComponent(String(publicId))}?data=APP_PAYOUTS`;
        }
        else {
            url = `${this._kcmssvcURL}/invoices/${encodeURIComponent(String(publicId))}`;
        }
        return this.httpClient.get<Invoice>(url,
            {
                withCredentials: null,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * get_invoice_list
     * Get Invoice List
     * @param customerId 
     * @param status 
     * @param from_date
     * @param to_date
     * @param limit 
     * @param start 
     * @param end 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInvoiceList(customerId: string, status: string,  from_date?: string, to_date?: string,limit?: string, start?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling getInvoiceList.');
        }
        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling getInvoiceList.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
       
        if ( from_date !== undefined && from_date !== null && from_date.toString() !== '') {
            queryParameters = queryParameters.set('from_date', <any> from_date);
        }

        if ( to_date !== undefined && to_date !== null && to_date.toString() !== '') {
            queryParameters = queryParameters.set('to_date', <any> to_date);
        }

        if (limit !== undefined && limit !== null && limit.toString() !== '') {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (start !== undefined && start !== null && start.toString() !== '') {
            queryParameters = queryParameters.set('start', <any>start);
        }
       
        if (status !== undefined && status !== null && status.toString() !== '') {
            queryParameters = queryParameters.set('status', <any>status);
        }

        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }

       

        return this.httpClient.get<InvoiceList>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(customerId))}/invoices`,
            {
                params: queryParameters
                ,withCredentials: null,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }//end method


  

    
     /**
     * get_invoice_list
     * Get Invoice List
     * @param customerId 
     * @param status 
     * @param date 
     * @param limit 
     * @param start 
     * @param end 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSalesInvoiceList(customerId: string, status: string, date?: string, limit?: number, start?: number, end?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling getInvoiceList.');
        }      
        return this.httpClient.get<InvoiceList>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(customerId))}/invoices`,
            {
               
            }
        );
    }

    /**
     * update_invoice
     * update_invoice
     * @param body 
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInvoice(body: Invoice, publicId: string, observe?: 'body', reportProgress?: boolean): Observable<Invoice>;
    public updateInvoice(body: Invoice, publicId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Invoice>>;
    public updateInvoice(body: Invoice, publicId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Invoice>>;
    public updateInvoice(body: Invoice, publicId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInvoice.');
        }
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling updateInvoice.');
        }

        let headers = this.defaultHeaders;

        return this.httpClient.patch<Invoice>(`${this._kcmssvcURL}/invoices/${encodeURIComponent(String(publicId))}`,
            body,
            {
                withCredentials: null,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     * Get Invoice Notifications
     * Get Invoice Notifications
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInvoiceNotificationList(publicId: string, observe?: 'body', reportProgress?: boolean): Observable<NotificationList>;
    public getInvoiceNotificationList(publicId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationList>>;
    public getInvoiceNotificationList(publicId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationList>>;
    public getInvoiceNotificationList(publicId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getInvoiceNotificationList.');
        }

        return this.httpClient.get<NotificationList>(`${this._kcmssvcURL}/invoices/${encodeURIComponent(String(publicId))}/notifications`,
            {
               
            }
        );
    }


        public async createInvoicePromise(body: Invoice, observe: any = 'response', reportProgress: boolean = false ) {
       
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createInvoice.');
        }

        let headers = this.defaultHeaders;

        return await this.httpClient.post<Invoice>(`${this._kcmssvcURL}/invoices`,
            body,
            {
                withCredentials: null,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }//end function

    public reportExport(customerId: string, status: string, from_date: string, to_date: string, search: string, template?:string): Observable<InvoiceReportExport> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customer ID was null or undefined');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (from_date !== undefined && from_date !== null && from_date.toString() !== '') {
            queryParameters = queryParameters.set('from_date', <string>from_date);
        }

        if (to_date !== undefined && to_date !== null && to_date.toString() !== '') {
            queryParameters = queryParameters.set('to_date', <string>to_date);
        }

        if (status !== undefined && status !== null && status !== '') {
            queryParameters = queryParameters.set('status', <string>status);
        }

        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <string>search);
        }
        
        if (template !== undefined && template !== null && template !== '') {
            queryParameters = queryParameters.set('template', <string>template);
        }

        return this.httpClient.get<InvoiceReportExport>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(customerId))}/invoices/export`,
            {
                params: queryParameters
            });
    }

    public getPartialInvoice(publicId: string): Observable<PartialInvoice> {
        let headers = this.defaultHeaders;

        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling getInvoiceList.');
        }

        return this.httpClient.get<PartialInvoice>(`${this._kcmssvcURL}/invoices/${encodeURIComponent(String(publicId))}/partials`,
            {
                withCredentials: null,
                headers: headers
            }
        );
    }
 
    public getInvoiceProperties(creditorId: any): Observable<any> {
        if (creditorId === null || creditorId === undefined) {
          throw new Error('Required parameter creditorId was null or undefined when calling getInvoiceProperties.');
        }
        return this.httpClient.get<any>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(creditorId))}/configurations/invoice.properties`);
      }

}//end class
